import { Button, Popover, Typography } from 'antd';

interface JsonCellProps {
  value: unknown;
  title?: string;
}

/**
 * Renders a "View JSON" link. Click to show the
 * pretty-printed JSON in a scrollable popover.
 */
function JsonCell({ value, title }: JsonCellProps) {
  if (value === null || value === undefined || value === '') return null;

  const pretty = JSON.stringify(value, null, 2);

  return (
    <Popover
      trigger="click"
      title={title}
      placement="left"
      content={
        <div style={{ maxWidth: '60vw', maxHeight: '60vh', overflow: 'auto' }}>
          <Typography.Paragraph
            copyable={{ text: pretty }}
            style={{ margin: 0 }}
          >
            <pre style={{ margin: 0 }}>{pretty}</pre>
          </Typography.Paragraph>
        </div>
      }
    >
      <Button size="small" type="link" style={{ padding: 0 }}>
        View JSON
      </Button>
    </Popover>
  );
}

export default JsonCell;
